export default __webpack_public_path__ + "static/media/icon-password-shown.953f4c49.svg";